import React, { useEffect, useState } from 'react';
import TruckMatePage from './TruckMatePage';
import { API_BASE } from '../config';
import { getDispatcher, getJwt, changeDispatcherPassword, markDispatcherMustChange } from '../traccar';
import SetPasswordForm from './SetPasswordForm';

// What a dispatcher account sees: only the AI dispatcher console, with their name
// and Sign out. If an admin turns the account off, the next check signs them out.
export default function DispatcherShell({ onSignOut }) {
  const me = getDispatcher() || {};
  const [mustChange, setMustChange] = useState(!!me.mustChange);
  // inside the TagAlong phone app: drop the consumer skin while the console is open
  useEffect(() => {
    const html = document.documentElement; const body = document.body;
    const had = { html: html.classList.contains('ta-app'), body: body.classList.contains('ta-app'), consumer: body.classList.contains('ta-consumer'), bgH: html.style.background, bgB: body.style.background };
    html.classList.remove('ta-app'); body.classList.remove('ta-app', 'ta-consumer');
    html.style.background = '#0a1a2f'; body.style.background = '#f8fafc';
    return () => {
      if (had.html) html.classList.add('ta-app'); if (had.body) body.classList.add('ta-app'); if (had.consumer) body.classList.add('ta-consumer');
      html.style.background = had.bgH; body.style.background = had.bgB;
    };
  }, []);
  useEffect(() => {
    const check = async () => {
      try {
        const r = await fetch(`${API_BASE}/auth/me`, { credentials: 'include', headers: getJwt() ? { Authorization: `Bearer ${getJwt()}` } : {} });
        if (r.status === 401) { onSignOut(); return; }
        const u = await r.json().catch(() => ({}));
        if (u && u.role && u.role !== 'dispatcher') onSignOut();
        // turned-off accounts: any dispatch call answers 401 → back to sign-in
        const t = await fetch(`${API_BASE}/truckmate/unclosed/settings`, { credentials: 'include', headers: getJwt() ? { Authorization: `Bearer ${getJwt()}` } : {} });
        if (t.status === 403) { const j = await t.json().catch(() => ({})); if (j && j.mustChange) { markDispatcherMustChange(); setMustChange(true); return; } }
        if (t.status === 401 || t.status === 403) onSignOut();
      } catch { /* offline — try again later */ }
    };
    check();
    const t = setInterval(check, 5 * 60000);
    return () => clearInterval(t);
  }, [onSignOut]);
  return (
    <div style={{ minHeight: '100vh', background: '#f8fafc' }}>
      <div className="dd-shell-bar" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 20px', paddingTop: 'max(10px, env(safe-area-inset-top))', background: '#0a1a2f', color: '#e2e8f0' }}>
        <b style={{ fontFamily: 'Poppins, sans-serif', whiteSpace: 'nowrap' }}>Dynamic Dispatch</b>
        <span className="dd-shell-tag" style={{ fontSize: 12, color: '#93c5fd', fontWeight: 700, whiteSpace: 'nowrap' }}>AI Dispatcher</span>
        <span style={{ marginLeft: 'auto', fontSize: 13, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{me.name || me.email || 'Dispatcher'}</span>
        <button type="button" onClick={onSignOut} style={{ background: 'rgba(255,255,255,0.1)', color: '#cbd5e1', border: '1px solid rgba(255,255,255,0.25)', borderRadius: 8, padding: '4px 10px', fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap', flex: 'none' }}>Sign out</button>
      </div>
      {mustChange ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '6vh 16px' }}>
          <div style={{ width: 'min(400px, 100%)', background: '#fff', borderRadius: 16, padding: 24, boxShadow: '0 10px 30px rgba(15,23,42,.12)' }}>
            <h2 style={{ margin: '0 0 6px', fontSize: 20 }}>Set your own password</h2>
            <p style={{ margin: '0 0 14px', fontSize: 14, color: '#475569' }}>Welcome{me.name ? `, ${String(me.name).split(' ')[0]}` : ''}. Your admin gave you a starting password — choose your own before you continue.</p>
            <SetPasswordForm onSave={async (cur, next) => { await changeDispatcherPassword(cur, next); setMustChange(false); }} cta="Save and open the console" />
          </div>
        </div>
      ) : <TruckMatePage />}
    </div>
  );
}
